import { mockSuccess } from './shared';
import type { MockRouteEntry } from '../mock-api.types';

const ACCESS_ROWS = [
    { id: 'bind-1', user_email: 'appadmin1@yopmail.com', organization_code: 'outbox', branch_code: 'main', role: '@ADMIN', status: 'active' },
    { id: 'bind-2', user_email: 'user.demo@yopmail.com', organization_code: 'outbox', branch_code: 'main', role: '@USER', status: 'active' },
];

let PROFILE_NOTIFICATIONS = {
    email_module_updates: true,
    email_billing: true,
    email_mailing_vetting: true,
    push_enabled: false,
};

export const PLATFORM_MOCK_HANDLERS: MockRouteEntry[] = [
    { method: 'GET', pattern: /\/api\/profile\/notifications/i, handler: () => mockSuccess(PROFILE_NOTIFICATIONS) },
    {
        method: 'PATCH',
        pattern: /\/api\/profile\/notifications/i,
        handler: (req) => {
            PROFILE_NOTIFICATIONS = { ...PROFILE_NOTIFICATIONS, ...(req.body as object) };
            return mockSuccess(PROFILE_NOTIFICATIONS);
        },
    },

    {
        method: 'GET',
        pattern: /\/api\/common\/messages/i,
        handler: () => mockSuccess([]),
    },
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/access\/list/i,
        handler: () => mockSuccess({ data: ACCESS_ROWS }),
    },
    {
        method: 'POST',
        pattern: /\/api\/[^/]+\/[^/]+\/access\/grant/i,
        handler: (req) => {
            const b = (req.body || {}) as Record<string, string>;
            ACCESS_ROWS.push({
                id: `bind-${ACCESS_ROWS.length + 1}`,
                user_email: b['user_email'] || 'new@yopmail.com',
                organization_code: b['organization_code'] || 'outbox',
                branch_code: b['branch_code'] || '',
                role: b['role'] || '@USER',
                status: 'active',
            });
            return mockSuccess({ ok: true });
        },
    },
    {
        method: 'POST',
        pattern: /\/api\/[^/]+\/[^/]+\/access\/revoke/i,
        handler: (req) => {
            const id = ((req.body || {}) as { id?: string }).id;
            const idx = ACCESS_ROWS.findIndex((r) => r.id === id);
            if (idx >= 0) {
                ACCESS_ROWS.splice(idx, 1);
            }
            return mockSuccess({ ok: true });
        },
    },
];
